// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Urbanist:ital,wght@0,100..900;1,100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: "Urbanist", sans-serif !important;
}

/* 
scss
 */
/* 
Body Theme Color
 */
/* 
Dark Theme Colors
*/
/* 
Button Theme
*/
/* 
Max Dashboard scss
*/
/* 
Min Dashboard scss
*/
/* 
Max Dashboard scss
*/
.settings_dashboard__FHk5D {
  width: calc(100% - 320px);
  position: relative;
  left: 310px;
  padding: 30px;
  border-radius: 8px;
  min-height: auto !important;
  background-color: #F5F6FA;
  height: calc(100vh - 160px);
  overflow-y: auto;
}

.settings_dashboardContain__U2OSm {
  width: calc(100% - 320px);
  background-Color: #F5F6FA;
  border-radius: 8px;
}

.settings_bodythemedark__CUjRX .settings_dashboardContain__U2OSm,
.settings_bodythemedark__CUjRX .settings_dashboard__FHk5D,
.settings_bodythemedark__CUjRX .settings_cont2__VlNwH {
  background-Color: #0f1824;
}

.settings_top_header__ff-Zj .settings_top_header_inner__CdYKG {
  background-color: transparent;
  height: auto;
  overflow-y: unset;
}

/* 
Min Dashboard scss
*/
.settings_cont2__VlNwH {
  width: calc(100% - 50px);
  left: 50px;
  position: relative;
  padding: 30px;
  border-radius: 8px;
  background: #F5F6FA;
  height: calc(100vh - 160px);
  min-height: auto !important;
  overflow-y: auto;
  /* 
  background-Color: \$dashboardbackgroundColor;
    padding-bottom: 8%;
  */
}

.settings_footer__P4xQU {
  height: 70px;
}

body {
  background-color: #fff;
}

/* 
THEME CHANGE
*/
.settings_bodythemelight__daVLj {
  background-color: #fff;
  padding-top: 90px;
}

.settings_bodythemedark__CUjRX {
  background-color: #132337;
  padding-top: 90px;
}

/* 
Header Navbar Theme
*/
.settings_headerthemelight__-DecU {
  background-color: #fff;
}

.settings_headerthemedark__VXMQL {
  background-color: #132337;
}

.settings_top_header__ff-Zj {
  min-height: 90px;
  display: flex;
  align-items: center;
  position: fixed;
  width: 100%;
  z-index: 1;
  top: 0;
}

/* 
LEFT MENU THEME CHANGE
*/
.settings_menuthemelight__xa936 {
  background-color: #fff;
}

.settings_menuthemedark__0RlW9 {
  background-color: #132337;
}

/* 
LEFT MENU LINKS THEME CHANGE
*/
.settings_menulinklight__2ukHf span {
  color: #666666 !important;
}

.settings_menulinklight__2ukHf a {
  color: #CBCBCB !important;
}

.settings_menulinklight__2ukHf:hover span, .settings_menulinklight__2ukHf:hover a {
  color: #fff !important;
}

.settings_menulinkdarkSelected__qg5eL {
  background-color: #1c2e45;
  color: #3b82f6;
}

.settings_menuthemelight__xa936 .settings_menulinklightSelected__-Sh8x {
  /*background-color: \$lightthemecolor;*/
  color: #fff !important;
  background-color: #131F43;
}

.settings_menulinkdark__ZEp0Q {
  color: #92afd3 !important;
}

.settings_menulinklight__2ukHf:hover {
  color: #fff !important;
  background-color: #131F43;
}

.settings_menulinklight__2ukHf .settings_sub_arrow__fGoo- svg path {
  stroke: #CBCBCB !important;
}

.settings_menulinklight__2ukHf:hover .settings_sub_arrow__fGoo- svg path {
  stroke: #fff !important;
}

.settings_menulinkdark__ZEp0Q .settings_sub_arrow__fGoo- svg path {
  stroke: #92afd3 !important;
}

.settings_menulinkdark__ZEp0Q:hover .settings_sub_arrow__fGoo- svg path {
  stroke: #fff !important;
}

.settings_menulinkdark__ZEp0Q:hover {
  background-color: #1c2e45;
  color: #fff;
}

/* 
BODY HEADERS
*/
.settings_headinglight__doSQ0 {
  color: #60677e;
}

.settings_headingdark__n\\+TEX {
  color: #60677e;
}

/* 
SEARCH BOX THEME COLOR
*/
.settings_searchboxlight__Exe8H {
  background-color: #fff;
  border: none;
}

.settings_searchboxdark__0LYGy {
  background-color: #132337;
  color: #fff;
  border: none;
}

.settings_searchboxdark__0LYGy::placeholder {
  color: #60677e;
}

/* 
CUSTOM TABLE THEME COLOR
*/
.settings_tableheadlight__I2wDM {
  background-color: #131F43;
  border-radius: 5px 5px 0px 0px;
}

.settings_tableheadlight__I2wDM th {
  color: #fff;
}

thead .settings_tableheadlight__I2wDM th:first-child,
thead .settings_tableheaddark__BAzcZ th:first-child {
  border-radius: 5px 0 0 0px;
}

thead .settings_tableheadlight__I2wDM th:last-child,
thead .settings_tableheaddark__BAzcZ th:last-child {
  border-radius: 0 5px 0px 0;
}

th:first-child {
  border-radius: 0px;
}

td:last-child {
  border-radius: 0px;
}

table.settings_table__wcs2I.settings_table-borderless__XlVcO {
  border-collapse: separate !important;
  border-spacing: 0 0px !important;
}

.settings_tableheaddark__BAzcZ {
  background-color: #132337;
  color: #fff;
}

.settings_table-borderless__XlVcO tr:nth-child(even) {
  background-color: #F9FAFB;
}

.settings_table-borderless__XlVcO .settings_left-section__Mo-jA {
  padding-top: 10px;
}

.settings_tablebodylight__F8haX td,
.settings_tablebodydark__qeszF td {
  padding: 0.5rem 1rem !important;
  line-height: 45px;
}

.settings_tablebodylight__F8haX {
  background-color: #fff;
}
.settings_tablebodylight__F8haX:hover {
  background-color: #ddecf9;
  cursor: auto;
}

.settings_tablebodydark__qeszF {
  /* background-color: \$primarydark-color; */
  color: #60677e;
}
.settings_tablebodydark__qeszF:hover {
  background-color: rgba(33, 150, 243, 0.1);
  cursor: auto;
}

/* 
PAGINATION THEME COLOR
*/
.settings_paginationlight__BGULt {
  color: #60677e !important;
  font-size: 13px !important;
}

.settings_paginationdark__Hz6pf {
  color: #60677e !important;
  font-size: 13px !important;
}

/* 
SETTING FORM THEME COLOR
*/
.settings_formthemelight__HnEnB {
  background-color: #fff;
  color: #1d1d1d !important;
  box-shadow: 0px 10px 35px 0px rgba(56, 71, 109, 0.08);
}

.settings_formthemedark__ffb0i {
  background-color: #132337;
  color: #60677e !important;
  font-size: 14px;
}
.settings_formthemedark__ffb0i ::placeholder {
  color: #60677e;
}

/* 
VIEW FORM DETAILS BOX THEME COLOR
*/
.settings_viewformlight__AIIgi {
  background-color: #f3f6f9;
}

.settings_permissionboxlight__UvL2i {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
}

.settings_permissionboxdark__qBhr4 {
  background-color: #0f1824;
  border: solid 1px #242434;
}

.settings_errormsgclr__QmeiF {
  color: red;
  font-size: 14px;
  margin-top: 5px;
}

/* 
Graph theme
*/
.settings_graphclrlight__rlfpD {
  background-color: #fff;
}

.settings_graphclrdark__tho2P {
  background-color: #132337;
}

/* 
Counter theme
*/
#settings_card1bglight__mR3L5 {
  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */
  background-color: #fff;
}

#settings_card1bgdark__HX9ph {
  background: #392f28;
}

#settings_card2bglight__\\+y-JH {
  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */
  background-color: #fff;
}

#settings_card2bgdark__Kfhe7 {
  background: #1c3238;
}

#settings_card3bglight__XbcQO {
  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */
  background-color: #fff;
}

#settings_card3bgdark__ILj6B {
  background: #3a2434;
}

#settings_card4bglight__fGD5L {
  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */
  background-color: #fff;
}

#settings_card4bgdark__0tK9O {
  background: #2f264f;
}

#settings_card1bgdark__HX9ph a, #settings_card1bgdark__HX9ph p,
#settings_card2bgdark__Kfhe7 a, #settings_card2bgdark__Kfhe7 p,
#settings_card3bgdark__ILj6B a, #settings_card3bgdark__ILj6B p,
#settings_card4bgdark__0tK9O a, #settings_card4bgdark__0tK9O p {
  color: #fff;
}

/* 
Action button theme
*/
.settings_actionbtnlight__4Sk0H {
  color: rgba(70, 71, 91, 0.8705882353);
}

.settings_actionbtnlight__4Sk0H:hover {
  cursor: pointer;
}

.settings_actionbtndark__La-Jh {
  color: #60677e;
}

/* 
profile dropdowntheme
*/
.settings_profiledropdownlight__NbgyO {
  background-color: #fff;
}

.settings_profiledropdowndark__D0QpQ {
  background-color: #151521;
}

.settings_settingsection__xu5at #settings_addform__Dk7Mj.settings_formthemedark__ffb0i .settings_savebtn__yNpbe {
  background-color: #3b82f6;
  color: #fff;
}

#settings_addform__Dk7Mj.settings_formthemedark__ffb0i .settings_savebtn__yNpbe {
  background-color: #3b82f6;
  color: #fff;
}

.settings_profile_conatiner__rzq8z {
  border-radius: 5px !important;
}

.settings_bodythemedark__CUjRX .settings_ag-theme-alpine__wCbtM .settings_ag-row__xu1As {
  background: #000 !important;
}

.settings_bodythemedark__CUjRX .settings_formbtn__mm3Wt {
  background-color: #3b82f6;
}

.settings_bodythemedark__CUjRX .settings_formbtn__mm3Wt:hover {
  background-color: #2563eb;
}

.settings_bodythemedark__CUjRX .settings_resetbtn__FRARY {
  color: #fff;
  background-color: transparent;
  border: solid 1px #3b82f6;
}

.settings_bodythemedark__CUjRX .settings_resetbtn__FRARY:hover {
  background-color: #3b82f6;
}

.settings_headingdark__n\\+TEX span {
  background-color: #132337;
}

.settings_resetbtn__FRARY {
  font-size: 16px;
  font-weight: 600;
  border-radius: 5px;
  background-color: transparent;
  border: solid 1px #131F43;
  color: #131F43;
  min-width: 113px;
}

.settings_resetbtn__FRARY:hover,
.settings_resetbtn__FRARY:active,
.settings_resetbtn__FRARY:focus {
  background-color: #131F43;
  color: #fff;
}

.settings_addBtn__eaiUM {
  min-width: 140px;
  height: 44px;
  color: #fff;
  background-color: #38A169;
  border: none;
  font-size: 16px;
  font-weight: 600;
}

.settings_addbtnlight__gWrRV {
  background-color: #38A169;
}

.settings_addbtndark__NmlKJ {
  background-color: #3b82f6;
}

.settings_addbtndark__NmlKJ:hover {
  background-color: #2563eb;
}

.settings_formthemedark__ffb0i label {
  color: #92afd3;
}

.settings_addBtn__eaiUM svg {
  margin-right: 10px;
  position: relative;
  top: 2px;
}

.settings_addBtn__eaiUM:hover {
  color: #fff;
  background-color: #38A169;
  border: none;
}

.settings_cust_addBtn__OhiGl.settings_addBtn__eaiUM svg {
  top: 2px;
}

.settings_deleteBtn__bL4Ju {
  min-width: 130px;
  height: 50px;
  background-color: #F94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.settings_deleteBtn__bL4Ju {
  min-width: 130px;
  height: 50px;
  background-color: #F94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.settings_deleteBtn__bL4Ju:active, .settings_deleteBtn__bL4Ju:focus {
  background-color: #F94747 !important;
  color: #fff !important;
  box-shadow: none !important;
}

.settings_deleteBtn__bL4Ju svg {
  margin-right: 10px;
  position: relative;
  top: -2px;
}

.settings_deleteBtn__bL4Ju:hover,
.settings_deleteBtn__bL4Ju:active,
.settings_deleteBtn__bL4Ju:focus {
  background-color: #F94747;
  color: #fff;
  border: none;
}

.settings_confirmBtn__Wnp0z {
  background-color: #131F43;
}

.settings_confirmBtn__Wnp0z:hover,
.settings_confirmBtn__Wnp0z:active,
.settings_confirmBtn__Wnp0z:focus {
  background-color: #131F43;
}

.settings_confirmBtn__Wnp0z svg {
  top: 0;
}

.settings_delPopContainer__FCjdY .settings_modal-body__MJgKL {
  padding: 25px;
  text-align: center;
}

.settings_delPopContainer__FCjdY .settings_delet_icon__uP6T3 {
  margin-bottom: 11px;
}

.settings_delPopContainer__FCjdY p {
  color: #131f43;
  font-size: 14px;
  font-weight: 700;
}

.settings_arrowback__qnVSX svg {
  fill: #000;
}

.settings_bodythemedark__CUjRX .settings_arrowback__qnVSX {
  background-color: rgba(59, 130, 246, 0.2);
  color: #3b82f6;
}

.settings_bodythemedark__CUjRX .settings_arrowback__qnVSX svg {
  fill: #3b82f6;
}

.settings_bodythemedark__CUjRX .settings_drpdwn_btn__PsPxB {
  background-color: #132337;
}

.settings_bodythemedark__CUjRX .settings_empname__6QldI {
  color: #92afd3 !important;
}

.settings_bodythemedark__CUjRX .settings_navitemli__4IC51 a {
  background-color: transparent;
  border: solid 1px #3b82f6;
  color: #fff;
}

.settings_bodythemedark__CUjRX .settings_tabnavli__-QWK2 a.settings_settingsgeneral__0GBoO,
.settings_bodythemedark__CUjRX .settings_tabnavli__-QWK2 a.settings_settingslinks__vcT1Z:hover {
  background-color: #3b82f6;
  color: #fff;
}

.settings_bodythemedark__CUjRX .settings_tabnavli__-QWK2 a.settings_settingslinks__vcT1Z {
  background-color: transparent;
  border: solid 1px #3b82f6;
  color: #fff;
}

.settings_headerthemedark__VXMQL .settings_dropdown_menu_contain__H2iGV {
  background-color: #1c2e45;
  color: #fff;
}

.settings_headerthemedark__VXMQL .settings_dropdown_menu_contain__H2iGV ul li a,
.settings_headerthemedark__VXMQL .settings_dropdown_menu_contain__H2iGV .settings_dropdown_item__Ioitd,
.settings_headerthemedark__VXMQL .settings_dropdown_menu_contain__H2iGV .settings_dropdown_item__Ioitd h5 {
  color: #fff;
}

.settings_headerthemedark__VXMQL .settings_dropdown_menu_contain__H2iGV ul li a:hover,
.settings_headerthemedark__VXMQL .settings_dropdown_menu_contain__H2iGV .settings_dropdown_item__Ioitd:hover {
  background-color: #132337;
  color: #fff;
}

.settings_dropdown_item__Ioitd:active {
  background-color: #F5F6FA;
}

.settings_profile_arrrow_dwn__\\+vDFh {
  stroke: #132337;
}

.settings_headerthemedark__VXMQL .settings_profile_arrrow_dwn__\\+vDFh {
  stroke: #fff;
}

.settings_dateinputbox1__enon- input,
.settings_dateinputbox1__enon- span {
  color: #fff !important;
}

/* LOGOUT MODAL */
@media only screen and (max-width: 1200px) {
  .settings_tableheadlight__I2wDM th {
    min-width: 100px;
  }
}
@media only screen and (max-width: 1024px) {
  .settings_dashboard__FHk5D {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    padding: 10px 10px !important;
  }
  .settings_cont2__VlNwH {
    height: calc(100vh - 160px);
    overflow-y: auto;
  }
}
@media only screen and (max-width: 998px) {
  /* #dashboardcont2{
     height: auto !important;
   }*/
}
@media only screen and (max-width: 767px) {
  .settings_sectionright__lAAyc {
    float: unset !important;
  }
  .settings_dashboard__FHk5D {
    padding: 10px 10px !important;
  }
}
@media only screen and (max-width: 600px) {
  .settings_cont2__VlNwH {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    position: relative !important;
    padding: 10px !important;
  }
  .settings_bodythemelight__daVLj, .settings_bodythemedark__CUjRX {
    padding-top: 110px;
  }
}
@media (min-width: 576px) {
  .settings_exer_modal_contain__Yk2sS .settings_modal-dialog__6cI4N {
    max-width: 1055px;
  }
  .settings_delPopContainer__FCjdY .settings_modal-dialog__6cI4N {
    max-width: 350px;
  }
}
.settings_settingsection__xu5at {
  margin-bottom: 50px;
  padding-bottom: 30px;
}
.settings_settingsection__xu5at #settings_settingsheading__E8AHc {
  font-size: 18px;
}
.settings_settingsection__xu5at .settings_settingslinks__vcT1Z {
  text-decoration: none;
  letter-spacing: 0.15em;
  display: inline-block;
  position: relative;
}
.settings_settingsection__xu5at .settings_settingsgeneral__0GBoO {
  text-decoration: none;
  letter-spacing: 0.15em;
  display: inline-block;
  position: relative;
  color: #fff;
  background-color: #131F43;
}
.settings_settingsection__xu5at .settings_formthemedark__ffb0i .settings_settingsgeneral__0GBoO {
  background-color: #3b82f6;
}
.settings_settingsection__xu5at .settings_settingslinks__vcT1Z:hover {
  color: #fff;
  background-color: #131F43;
}
.settings_settingsection__xu5at .settings_formthemedark__ffb0i .settings_settingslinks__vcT1Z:hover {
  color: #fff;
  background-color: #3b82f6;
}
.settings_settingsection__xu5at .settings_settingsgeneral__0GBoO:hover {
  color: #fff;
  background-color: #131F43;
}
.settings_settingsection__xu5at #settings_layoutnav__xQYLn {
  border-radius: 5px;
}
.settings_settingsection__xu5at #settings_addform__Dk7Mj {
  margin-top: 30px;
  padding: 30px;
  border-radius: 5px;
  display: flex;
}
.settings_settingsection__xu5at #settings_addform__Dk7Mj form {
  width: 100%;
}
.settings_settingsection__xu5at #settings_addform__Dk7Mj .settings_wrapper__FyIeM {
  width: 100%;
  padding-left: 30px;
}
.settings_settingsection__xu5at #settings_addform__Dk7Mj .settings_savebtn__yNpbe {
  border: none;
  border-radius: 5px;
  background-color: #131F43;
  padding: 10px;
  color: #fff;
  font-size: 14px;
  margin-top: 10px;
}
.settings_settingsection__xu5at #settings_addform__Dk7Mj .settings_inputbox__7agbd {
  border-radius: 5px;
  width: 100%;
  font-size: 14px;
}
.settings_settingsection__xu5at #settings_addform__Dk7Mj .settings_inputbox1__5RkFm {
  padding: 10px;
  border: none;
  border-radius: 5px;
  width: 100%;
  background-color: #0f1824;
  color: #fff;
}
.settings_settingsection__xu5at #settings_addform__Dk7Mj .settings_formlabel__Bs5lx {
  font-size: 14px;
}
.settings_settingsection__xu5at #settings_addform__Dk7Mj .settings_formlabel1__b1qS9 {
  color: #f8f9fa;
  font-size: 12px;
}
.settings_settingsection__xu5at #settings_addform__Dk7Mj .settings_logo__2Nn6k {
  border: 1px solid rgba(81, 83, 101, 0.28);
  padding: 10px;
  margin-bottom: 20px;
  border-radius: 5px;
  width: 510px;
}
.settings_settingsection__xu5at #settings_addform__Dk7Mj .settings_editbtnsection__8ps9W {
  position: relative;
  margin-top: -37px;
}
.settings_settingsection__xu5at #settings_addform__Dk7Mj #settings_penicon__ZuNGm {
  margin-left: 175px;
  font-size: 14px;
  background-color: #60677e;
  padding: 5px;
  border-radius: 50%;
  color: #e9ecef;
  cursor: pointer;
}
.settings_settingsection__xu5at #settings_addform__Dk7Mj #settings_penicon__ZuNGm:hover {
  background-color: #131F43;
}

.settings_formthemedark__ffb0i .settings_settingsgeneral__0GBoO:hover {
  background-color: #3b82f6;
}

.settings_upload__Nn90h {
  border: 1px solid #dee2e6;
  background-color: #f8f9fa;
  padding: 6px 0px 0px 3px;
  width: 90px;
  margin-left: 205px;
  margin-top: -45px;
  border-radius: 5px;
}

.settings_uploadicon__tIHlL {
  color: #1d1d1d;
  font-size: 18px;
  cursor: pointer;
}
.settings_uploadicon__tIHlL:hover {
  color: #131F43;
}

.settings_crossicon__Z8MI\\+ {
  color: #1d1d1d;
  font-size: 16px;
  margin-left: 40px;
  cursor: pointer;
}
.settings_crossicon__Z8MI\\+:hover {
  color: #131F43;
}

@media only screen and (max-width: 1200px) {
  .settings_logo__2Nn6k {
    width: 300px !important;
  }
}
@media only screen and (max-width: 878px) {
  #settings_layoutnav__xQYLn {
    display: flex !important;
  }
}
@media only screen and (max-width: 768px) {
  #settings_addform__Dk7Mj {
    display: block !important;
  }
  .settings_wrapper__FyIeM {
    padding-left: 0px !important;
  }
  .settings_logo__2Nn6k {
    width: 100% !important;
  }
  .settings_settingsection__xu5at #settings_layoutnav__xQYLn li {
    margin-bottom: 10px;
  }
}
@media only screen and (max-width: 548px) {
  .settings_settingslinks__vcT1Z {
    font-size: 14px !important;
  }
  .settings_settingsgeneral__0GBoO {
    font-size: 14px !important;
  }
}
@media only screen and (max-width: 400px) {
  .settings_settingslinks__vcT1Z {
    margin-right: 0px !important;
    font-size: 13px !important;
  }
  .settings_settingsgeneral__0GBoO {
    font-size: 13px !important;
  }
}
@media only screen and (max-width: 600px) {
  #settings_dashboardcont2__qbjfj {
    width: calc(100% - 50px);
    left: 50px;
    position: relative;
    padding: 30px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/Variables/Variables.scss","webpack://./src/pages/settings/settings.module.scss"],"names":[],"mappings":"AAEA;EACE,8CAAA;ACAF;;ADGA;;EAAA;AAkDA;;EAAA;AAWA;;CAAA;AAKA;;CAAA;AASA;;CAAA;AAQA;;CAAA;AAMA;;CAAA;AAIA;EACE,yBAhBe;EAiBf,kBAAA;EACA,WAhBc;EAiBd,aAhBiB;EAiBjB,kBAAA;EACA,2BAAA;EACA,yBA1FO;EA2FP,2BAAA;EACA,gBAAA;ACxEF;;AD0EA;EACE,yBAAA;EACA,yBAhGO;EAiGP,kBAAA;ACvEF;;ADyEA;;;EAGE,yBAlEoB;ACJtB;;ADwEA;EACE,6BAAA;EACA,YAAA;EACA,iBAAA;ACrEF;;ADwEA;;CAAA;AAIA;EACE,wBAvCU;EAwCV,UAvCS;EAwCT,kBAAA;EACA,aA/CiB;EAgDjB,kBAAA;EACA,mBAxHO;EAyHP,2BAAA;EACA,2BAAA;EACA,gBAAA;EACA;;;GAAA;ACnEF;;AD4EA;EACE,YAAA;ACzEF;;AD4EA;EACE,sBA5FY;ACmBd;;AD4EA;;CAAA;AAGA;EACE,sBAnGY;EAoGZ,iBAAA;ACzEF;;AD2EA;EACE,yBAlHgB;EAmHhB,iBAAA;ACxEF;;AD2EA;;CAAA;AAGA;EACE,sBA/GY;ACuCd;;AD2EA;EACE,yBA9HgB;ACsDlB;;AD0EA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;EACA,MAAA;ACvEF;;AD0EA;;CAAA;AAGA;EACE,sBAnIY;AC4Dd;;ADyEA;EACE,yBAjJgB;AC2ElB;;ADyEA;;CAAA;AAGA;EACE,yBAAA;ACtEF;;ADyEA;EACE,yBAAA;ACtEF;;ADyEA;EACE,sBAAA;ACtEF;;ADyEA;EACE,yBAlKsB;EAmKtB,cA7KkB;ACuGpB;;ADwEA;EACE,sCAAA;EACA,sBAAA;EACA,yBA5Mc;ACuIhB;;ADwEA;EACE,yBAAA;ACrEF;;ADwEA;EACE,sBAAA;EACA,yBArNc;ACgJhB;;ADwEA;EACE,0BAAA;ACrEF;;ADwEA;EACE,uBAAA;ACrEF;;ADwEA;EACE,0BAAA;ACrEF;;ADwEA;EACE,uBAAA;ACrEF;;ADwEA;EACE,yBArMsB;EAsMtB,WA7LY;ACwHd;;ADwEA;;CAAA;AAGA;EACE,cAjMe;AC4HjB;;ADwEA;EACE,cArMe;ACgIjB;;ADwEA;;CAAA;AAGA;EACE,sBA/MY;EAgNZ,YAAA;ACrEF;;ADwEA;EACE,yBA/NgB;EAgOhB,WArNY;EAsNZ,YAAA;ACrEF;;ADuEA;EACE,cAtNe;ACkJjB;;ADuEA;;CAAA;AAGA;EACE,yBA7Qc;EA8Qd,8BAAA;ACpEF;;ADsEA;EACE,WApOY;ACiKd;;ADqEA;;EAEE,0BAAA;AClEF;;ADoEA;;EAEE,0BAAA;ACjEF;;ADmEA;EACE,kBAAA;AChEF;;ADkEA;EACE,kBAAA;AC/DF;;ADiEA;EACE,oCAAA;EACA,gCAAA;AC9DF;;ADiEA;EACE,yBAlPkB;EAmPlB,WA3PY;AC6Ld;;ADgEA;EACE,yBAAA;AC7DF;;AD+DA;EACE,iBAAA;AC5DF;;AD8DA;;EAEE,+BAAA;EACA,iBAAA;AC3DF;;AD6DA;EACE,sBAzQY;AC+Md;AD4DE;EACE,yBAAA;EACA,YAAA;AC1DJ;;AD6DA;EACC,0CAAA;EACC,cA/Qe;ACqNjB;AD4DE;EACE,yCAAA;EACA,YAAA;AC1DJ;;AD8DA;;CAAA;AAGA;EACE,yBAAA;EACA,0BAAA;AC3DF;;AD6DA;EACE,yBAAA;EACA,0BAAA;AC1DF;;AD6DA;;CAAA;AAGA;EACE,sBA1SY;EA2SZ,yBAAA;EACA,qDAAA;AC1DF;;AD4DA;EACE,yBAvSkB;EAwSlB,yBAAA;EACA,eAAA;ACzDF;AD2DE;EACE,cAjTa;ACwPjB;;AD8DA;;CAAA;AAGA;EACE,yBAhUgB;ACqQlB;;AD8DA;EACE,yBAAA;EACA,yBAAA;AC3DF;;AD6DA;EACE,yBA/UoB;EAgVpB,yBAAA;AC1DF;;AD6DA;EACE,UAAA;EACA,eAAA;EACA,eAAA;AC1DF;;AD6DA;;CAAA;AAGA;EACE,sBAnVY;ACyRd;;AD6DA;EACE,yBA/UkB;ACqRpB;;AD8DA;;CAAA;AAGA;EACE,iGAAA;EACA,sBAhWY;ACqSd;;AD8DA;EACE,mBAAA;AC3DF;;AD8DA;EACE,gGAAA;EACA,sBAzWY;AC8Sd;;AD8DA;EACE,mBAAA;AC3DF;;AD8DA;EACE,gGAAA;EACA,sBAlXY;ACuTd;;AD8DA;EACE,mBAAA;AC3DF;;AD8DA;EACE,gGAAA;EACA,sBA3XY;ACgUd;;AD8DA;EACE,mBAAA;AC3DF;;AD8DA;;;;EAIE,WAtYY;AC2Ud;;AD8DA;;CAAA;AAGA;EACE,qCAAA;AC3DF;;AD6DA;EACE,eAAA;AC1DF;;AD4DA;EACE,cAhZe;ACuVjB;;AD6DA;;CAAA;AAGA;EACE,sBAAA;AC1DF;;AD6DA;EACE,yBAAA;AC1DF;;AD6DA;EACE,yBApbkB;EAqblB,WApaY;AC0Wd;;AD4DA;EACE,yBAxbkB;EAyblB,WAxaY;AC+Wd;;AD4DA;EACE,6BAAA;ACzDF;;AD4DA;EACE,2BAAA;ACzDF;;AD4DA;EACE,yBArckB;AC4YpB;;AD4DA;EACE,yBAxcwB;AC+Y1B;;AD4DA;EACE,WA5bY;EA6bZ,6BAAA;EACA,yBAAA;ACzDF;;AD4DA;EACE,yBAndkB;AC0ZpB;;AD6DA;EACE,yBAldgB;ACwZlB;;AD6DA;EACE,eAAA;EACA,gBA/fc;EAggBd,kBAAA;EACA,6BAAA;EACA,yBAAA;EACA,cA7fc;EA8fd,gBAAA;AC1DF;;AD4DA;;;EAGE,yBAngBc;EAogBd,WAvdY;AC8Zd;;AD4DA;EACE,gBAAA;EACA,YAAA;EACA,WA7dY;EA8dZ,yBAzfY;EA0fZ,YAAA;EACA,eAAA;EACA,gBAphBc;AC2dhB;;AD4DA;EACE,yBAhgBY;ACucd;;AD2DA;EACE,yBAzfkB;ACicpB;;AD0DA;EACE,yBA3fwB;ACoc1B;;AD0DA;EACE,cAjgBiB;AC0cnB;;AD2DA;EACE,kBAAA;EACA,kBAAA;EACA,QAAA;ACxDF;;AD2DA;EACE,WA1fY;EA2fZ,yBAthBY;EAuhBZ,YAAA;ACxDF;;AD2DA;EACE,QAAA;ACxDF;;AD2DA;EACE,gBAAA;EACA,YAAA;EACA,yBA1hBW;EA2hBX,WAvgBY;EAwgBZ,eAAA;EACA,gBA5jBc;EA6jBd,YAAA;ACxDF;;AD2DA;EACE,gBAAA;EACA,YAAA;EACA,yBApiBW;EAqiBX,WAjhBY;EAkhBZ,eAAA;EACA,gBAtkBc;EAukBd,YAAA;ACxDF;;AD2DA;EACE,oCAAA;EACA,sBAAA;EACA,2BAAA;ACxDF;;AD2DA;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;ACxDF;;AD2DA;;;EAGE,yBA1jBW;EA2jBX,WAviBY;EAwiBZ,YAAA;ACxDF;;AD2DA;EACE,yBAzlBc;ACiiBhB;;AD2DA;;;EAGE,yBA/lBc;ACuiBhB;;AD2DA;EACE,MAAA;ACxDF;;AD6DA;EACE,aAAA;EACA,kBAAA;AC1DF;;AD6DA;EACE,mBAAA;AC1DF;;AD6DA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AC1DF;;AD6DA;EACE,UAAA;AC1DF;;AD6DA;EACE,yCA9lBc;EA+lBd,cAnmBkB;ACyiBpB;;AD6DA;EACE,aAvmBkB;AC6iBpB;;AD6DA;EACE,yBAnmBgB;ACyiBlB;;AD6DA;EACE,yBAAA;AC1DF;;AD6DA;EACE,6BAAA;EACA,yBAAA;EACA,WAlmBY;ACwiBd;;AD6DA;;EAEE,yBAxnBkB;EAynBlB,WAxmBY;AC8iBd;;AD4DA;EACE,6BAAA;EACA,yBAAA;EACA,WA7mBY;ACojBd;;AD4DA;EACE,yBA1nBsB;EA2nBtB,WAlnBY;ACyjBd;;AD4DA;;;EAGE,WAxnBY;AC+jBd;;AD4DA;;EAEE,yBAxoBgB;EAyoBhB,WA9nBY;ACqkBd;;AD4DA;EACE,yBAhrBO;ACunBT;;AD4DA;EACE,eAjpBgB;ACwlBlB;;AD4DA;EACE,YA1oBY;ACilBd;;AD4DA;;EAEE,sBAAA;ACzDF;;AD4DA,iBAAA;AAUA;EACE;IACE,gBAAA;EClEF;AACF;ADoEA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;EClEF;EDoEA;IACE,2BAAA;IACA,gBAAA;EClEF;AACF;ADoEA;EACC;;KAAA;AChED;ADoEA;EACE;IACE,uBAAA;EClEF;EDoEA;IACE,6BAAA;EClEF;AACF;ADoEA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;IACA,wBAAA;EClEF;EDoEA;IACE,kBAAA;EClEF;AACF;ADqEA;EACE;IACI,iBAAA;ECnEJ;EDqEA;IACI,gBAAA;ECnEJ;AACF;AApsBA;EACI,mBAAA;EACA,oBAAA;AAssBJ;AApsBI;EACI,eAAA;AAssBR;AApsBI;EACI,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,kBAAA;AAssBR;AAnsBI;EACI,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,kBAAA;EACA,WDyCM;ECxCN,yBDqDW;ACgpBnB;AAnsBI;EACI,yBDoBY;ACirBpB;AAlsBI;EACI,WDiCM;EChCN,yBD6CW;ACupBnB;AAjsBI;EACI,WD4BM;EC3BN,yBDUY;ACyrBpB;AAhsBI;EACI,WDuBM;ECtBN,yBDmCW;AC+pBnB;AA7qBK;EACG,kBAAA;AA+qBR;AA5qBM;EACI,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;AA8qBV;AA7qBU;EACE,WAAA;AA+qBZ;AA7qBU;EACE,WAAA;EACA,kBAAA;AA+qBZ;AA5qBgB;EACI,YAAA;EACA,kBAAA;EACA,yBDND;ECOC,aAAA;EACA,WDrBN;ECsBM,eAAA;EACA,gBAAA;AA8qBpB;AA5qBgB;EACI,kBAAA;EACA,WAAA;EACA,eAAA;AA8qBpB;AA5qBgB;EACI,aAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,yBD7CE;EC8CF,WDpCN;ACktBd;AA5qBgB;EAEI,eAAA;AA6qBpB;AA3qBgB;EACI,cAAA;EAEA,eAAA;AA4qBpB;AAzqBgB;EACI,yCAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;AA2qBpB;AAzqBgB;EACI,kBAAA;EACA,iBAAA;AA2qBpB;AAxqBgB;EACI,kBAAA;EACA,eAAA;EACA,yBD5DH;EC6DG,YAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AA0qBpB;AAxqBqB;EACG,yBDzDL;ACmuBnB;;AAlqBA;EACI,yBDhGgB;ACqwBpB;;AAlqBA;EACI,yBAAA;EACA,yBAAA;EACA,wBAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;AAqqBJ;;AAnqBA;EACI,cD3FU;EC4FV,eAAA;EACA,eAAA;AAsqBJ;AApqBI;EACI,cDpFW;AC0vBnB;;AAnqBA;EACI,cDpGU;ECqGV,eAAA;EACA,iBAAA;EACA,eAAA;AAsqBJ;AApqBI;EACG,cD9FY;ACowBnB;;AA/pBA;EACI;IACI,uBAAA;EAkqBN;AACF;AAhqBA;EACG;IACC,wBAAA;EAkqBF;AACF;AA/pBA;EACI;IACI,yBAAA;EAiqBN;EA/pBE;IACI,4BAAA;EAiqBN;EA/pBE;IACI,sBAAA;EAiqBN;EA/pBE;IACI,mBAAA;EAiqBN;AACF;AA/pBA;EAEI;IACC,0BAAA;EAgqBH;EA7pBE;IACI,0BAAA;EA+pBN;AACF;AA3pBC;EAEG;IACC,4BAAA;IACA,0BAAA;EA4pBH;EAzpBE;IACI,0BAAA;EA2pBN;AACF;AAxpBA;EACI;IACI,wBDvII;ICwIJ,UDvIG;ICwIH,kBAAA;IACA,aD/IW;ECyyBjB;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Urbanist:ital,wght@0,100..900;1,100..900&display=swap');\n\nbody {\n  font-family: \"Urbanist\", sans-serif !important;\n}\n\n/* \nscss\n */\n$font-regular: 400;\n$font-medium: 500;\n$font-semiBold: 600;\n$font-bold: 700;\n$font-extraBold: 800;\n$font-black: 900;\n\n$mainBg: #F5F6FA;\n$primary-color: #131F43;\n$icon-bgcolor: #F6F6F6;\n$text-graycolor: #727272;\n$cardIcon1-bg: #F3F4F8;\n$cardIcon1-darkbg: #30231a;\n$cardIcon1-darkbg-icon: #9d785f;\n$cardIcon2-bg: #FAF4FB;\n$cardIcon2-darkbg: #13252a;\n$cardIcon2-darkbg-icon: #3b606a;\n$cardIcon3-bg: #FAF7F3;\n$cardIcon3-darkbg: #2c1a27;\n$cardIcon3-darkbg-icon: #6c4863;\n$cardIcon4-bg: #F5F9FC;\n$cardIcon4-darkbg: #241d3e;\n$cardIcon4-darkbg-icon: #5f538b;\n$cardIcon2-color: #AC44BB;\n$cardIcon3-color: #D69A5F;\n$cardIcon4-color: #176CA5;\n$green-color: #38A169;\n$darkGreen-color: #207a4a;\n$placeholder-color: #666666;\n$profile-dark-text: #181818;\n$heading : #0B0D0F;\n$light-gray : #999999;\n$menu_icon : #CBCBCB;\n$red-color : #F94747;\n$dark-active-blue : #3b82f6;\n$dark-light-blue : #92afd3;\n$addBtn-dark-blue : #3b82f6;\n$addBtn-dark-blue-hover : #2563eb;\n$backBtn-dark : #3b82f633;\n\n\n\n$darkTheme_blue : #132337;\n$darkTheme_darkBlue : #0f1824;\n$darkTheme_selectBlue : #1c2e45;\n$darkTheme_updateBtn : #0a2574;\n\n/* \nBody Theme Color\n */\n$lightthemecolor: #f3f6f9;\n$darkthemecolor: #151521;\n\n$white-color: #fff;\n$black-color: #1d1d1d;\n$fullBlack-color: #1d1d1d;\n$lightthemetext: #60677e;\n\n/* \nDark Theme Colors\n*/\n$primarydark-color: #132337;\n\n/* \nButton Theme\n*/\n$primary-btncolor: #131F43;\n$secondary-btncolor: rgba(37, 105, 109, 0.864);\n\n$tableheadlightbg: #e9eaf0;\n\n\n/* \nMax Dashboard scss\n*/\n$dashboardwidth: calc(100% - 320px);\n$dashboardposition: absolute;\n$dashboardleft: 310px;\n$dashboardpadding: 30px;\n\n/* \nMin Dashboard scss\n*/\n$dashwidth: calc(100% - 50px);\n$dashleft: 50px;\n\n/* \nMax Dashboard scss\n*/\n\n.dashboard {\n  width: $dashboardwidth;\n  position: relative;\n  left: $dashboardleft;\n  padding: $dashboardpadding;\n  border-radius: 8px;\n  min-height: auto !important;\n  background-color: $mainBg;\n  height: calc(100vh - 160px);\n  overflow-y: auto;\n}\n.dashboardContain { \n  width: calc(100% - 320px);\n  background-Color:$mainBg;\n  border-radius: 8px;\n}\n.bodythemedark .dashboardContain,\n.bodythemedark .dashboard, \n.bodythemedark .cont2 { \n  background-Color: $darkTheme_darkBlue;\n}\n.top_header .top_header_inner {\n  background-color: transparent;\n  height: auto;\n  overflow-y: unset;\n}\n\n/* \nMin Dashboard scss\n*/\n\n.cont2 {\n  width: $dashwidth;\n  left: $dashleft;\n  position: relative;\n  padding: $dashboardpadding;\n  border-radius: 8px;\n  background: $mainBg;\n  height: calc(100vh - 160px);\n  min-height: auto !important;\n  overflow-y: auto;\n  /* \nbackground-Color: $dashboardbackgroundColor;\n  padding-bottom: 8%;\n*/\n}\n\n\n\n\n.footer {\n  height: 70px;\n}\n\nbody {\n  background-color: $white-color;\n}\n\n/* \nTHEME CHANGE\n*/\n.bodythemelight {\n  background-color: $white-color;\n  padding-top: 90px;\n}\n.bodythemedark {\n  background-color: $darkTheme_blue;\n  padding-top: 90px;\n}\n\n/* \nHeader Navbar Theme\n*/\n.headerthemelight {\n  background-color: $white-color;\n}\n\n.headerthemedark {\n  background-color: $darkTheme_blue;\n}\n.top_header {\n  min-height: 90px;\n  display: flex;\n  align-items: center;\n  position: fixed;\n  width: 100%;\n  z-index: 1; \n  top: 0;\n}\n\n/* \nLEFT MENU THEME CHANGE\n*/\n.menuthemelight {\n  background-color: $white-color;\n}\n.menuthemedark {\n  background-color: $darkTheme_blue;\n}\n\n/* \nLEFT MENU LINKS THEME CHANGE\n*/\n.menulinklight span {\n  color: $placeholder-color !important;\n}\n\n.menulinklight a {\n  color: $menu_icon !important;\n}\n\n.menulinklight:hover span, .menulinklight:hover a { \n  color: $white-color !important;\n}\n\n.menulinkdarkSelected {\n  background-color: $darkTheme_selectBlue;\n  color: $dark-active-blue;\n}\n.menuthemelight .menulinklightSelected {\n  /*background-color: $lightthemecolor;*/\n  color: $white-color !important;\n  background-color: $primary-color;\n}\n\n.menulinkdark {\n  color: $dark-light-blue !important;\n}\n\n.menulinklight:hover {\n  color: $white-color !important;\n  background-color: $primary-color;\n}\n\n.menulinklight .sub_arrow svg path{\n  stroke: $menu_icon !important;\n}\n\n.menulinklight:hover .sub_arrow svg path{\n  stroke: $white-color !important;\n}\n\n.menulinkdark .sub_arrow svg path{\n  stroke: $dark-light-blue !important;\n}\n\n.menulinkdark:hover .sub_arrow svg path{\n  stroke: $white-color !important;\n}\n\n.menulinkdark:hover {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n/* \nBODY HEADERS\n*/\n.headinglight {\n  color: $lightthemetext;\n}\n\n.headingdark {\n  color: $lightthemetext;\n}\n\n/* \nSEARCH BOX THEME COLOR\n*/\n.searchboxlight {\n  background-color: $white-color;\n  border: none;\n}\n\n.searchboxdark {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n  border: none;\n}\n.searchboxdark::placeholder {\n  color: $lightthemetext;\n}\n\n/* \nCUSTOM TABLE THEME COLOR\n*/\n.tableheadlight {\n  background-color: $primary-color;\n  border-radius: 5px 5px 0px 0px;\n}\n.tableheadlight th {\n  color: $white-color;\n}\nthead .tableheadlight th:first-child,\nthead .tableheaddark th:first-child {\n  border-radius: 5px 0 0 0px;\n} \nthead .tableheadlight th:last-child,\nthead .tableheaddark th:last-child  {\n  border-radius: 0 5px 0px 0;\n}\nth:first-child {\n  border-radius: 0px;\n} \ntd:last-child {\n  border-radius: 0px;\n}\ntable.table.table-borderless{\n  border-collapse: separate !important;\n  border-spacing: 0 0px !important;\n}\n\n.tableheaddark {\n  background-color: $primarydark-color;\n  color: $white-color;\n}\n.table-borderless tr:nth-child(even) {\n  background-color: #F9FAFB;\n}\n.table-borderless .left-section {\n  padding-top: 10px;\n}\n.tablebodylight td, \n.tablebodydark td {\n  padding: 0.5rem 1rem !important;\n  line-height: 45px;\n}\n.tablebodylight {\n  background-color: $white-color;\n\n  &:hover {\n    background-color: #ddecf9;\n    cursor: auto;\n  }\n}\n.tablebodydark {\n /* background-color: $primarydark-color; */\n  color: $lightthemetext;\n\n  &:hover {\n    background-color: rgba(33, 150, 243, 0.1);\n    cursor: auto;\n  }\n}\n\n/* \nPAGINATION THEME COLOR\n*/\n.paginationlight {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n.paginationdark {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n\n/* \nSETTING FORM THEME COLOR\n*/\n.formthemelight {\n  background-color: $white-color;\n  color: $black-color !important;\n  box-shadow: 0px 10px 35px 0px rgb(56 71 109 / 8%);\n}\n.formthemedark {\n  background-color: $primarydark-color;\n  color: $lightthemetext !important;\n  font-size: 14px;\n\n  ::placeholder {\n    color: $lightthemetext;\n  }\n}\n\n\n/* \nVIEW FORM DETAILS BOX THEME COLOR\n*/\n.viewformlight {\n  background-color: $lightthemecolor;\n}\n\n.permissionboxlight {\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n}\n.permissionboxdark {\n  background-color: $darkTheme_darkBlue;\n  border: solid 1px #242434;\n}\n\n.errormsgclr {\n  color: red;\n  font-size: 14px;\n  margin-top: 5px;\n}\n\n/* \nGraph theme\n*/\n.graphclrlight {\n  background-color: $white-color;\n}\n\n.graphclrdark {\n  background-color: $primarydark-color;\n}\n\n\n/* \nCounter theme\n*/\n#card1bglight {\n  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card1bgdark {\n  background: #392f28;\n}\n\n#card2bglight {\n  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card2bgdark {\n  background: #1c3238;\n}\n\n#card3bglight {\n  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card3bgdark {\n  background: #3a2434;\n}\n\n#card4bglight {\n  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card4bgdark {\n  background: #2f264f;\n}\n\n#card1bgdark a, #card1bgdark p,\n#card2bgdark a , #card2bgdark p,\n#card3bgdark a, #card3bgdark p,\n#card4bgdark a, #card4bgdark p {\n  color: $white-color;\n}\n\n/* \nAction button theme\n*/\n.actionbtnlight {\n  color: #46475bde;\n}\n.actionbtnlight:hover{\n  cursor: pointer;\n}\n.actionbtndark {\n  color: $lightthemetext;\n}\n\n\n/* \nprofile dropdowntheme\n*/\n.profiledropdownlight {\n  background-color: #fff;\n}\n\n.profiledropdowndark {\n  background-color: #151521;\n}\n\n.settingsection #addform.formthemedark .savebtn {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n#addform.formthemedark .savebtn {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.profile_conatiner {\n  border-radius: 5px !important; \n}\n\n.bodythemedark .ag-theme-alpine .ag-row {\n  background: #000 !important;\n}\n\n.bodythemedark .formbtn {\n  background-color: $addBtn-dark-blue;\n}\n\n.bodythemedark .formbtn:hover {\n  background-color: $addBtn-dark-blue-hover;\n}\n\n.bodythemedark .resetbtn {\n  color: $white-color;\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n}\n\n.bodythemedark .resetbtn:hover {\n  background-color: $addBtn-dark-blue;\n}\n\n\n.headingdark span {\n  background-color: $darkTheme_blue;\n}\n\n.resetbtn {\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border-radius: 5px;\n  background-color: transparent;\n  border: solid 1px $primary-color;\n  color:  $primary-color;\n  min-width: 113px;\n}\n.resetbtn:hover, \n.resetbtn:active, \n.resetbtn:focus {\n  background-color: $primary-color;\n  color: $white-color;\n}\n\n.addBtn {\n  min-width: 140px;\n  height: 44px;\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n}\n\n.addbtnlight {\n  background-color: $green-color;\n}\n.addbtndark {\n  background-color: $addBtn-dark-blue;\n}\n.addbtndark:hover {\n  background-color: $addBtn-dark-blue-hover;\n}\n\n.formthemedark label {\n  color: $dark-light-blue;\n}\n\n\n.addBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: 2px;\n}\n\n.addBtn:hover {\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n}\n\n.cust_addBtn.addBtn svg {\n  top: 2px;\n}\n\n.deleteBtn {\n  min-width: 130px;\n  height: 50px;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn {\n  min-width: 130px;\n  height: 50px;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn:active, .deleteBtn:focus {\n  background-color: $red-color !important;\n  color: $white-color !important; \n  box-shadow: none !important;\n}\n\n.deleteBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: -2px;\n}\n\n.deleteBtn:hover, \n.deleteBtn:active, \n.deleteBtn:focus {\n  background-color: $red-color;\n  color: $white-color;\n  border: none;\n}\n\n.confirmBtn {\n  background-color: $primary-color;\n}\n\n.confirmBtn:hover, \n.confirmBtn:active, \n.confirmBtn:focus {\n  background-color: $primary-color;\n}\n\n.confirmBtn svg {\n  top: 0;\n}\n\n\n\n.delPopContainer .modal-body {\n  padding: 25px;\n  text-align: center;\n}\n\n.delPopContainer .delet_icon {\n  margin-bottom: 11px;\n}\n\n.delPopContainer p {\n  color: #131f43;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.arrowback svg{\n  fill: #000; \n}\n\n.bodythemedark .arrowback {\n  background-color: $backBtn-dark; \n  color: $dark-active-blue;\n}\n\n.bodythemedark .arrowback svg {\n  fill: $dark-active-blue;\n}\n\n.bodythemedark .drpdwn_btn {\n  background-color: $darkTheme_blue;\n}\n\n.bodythemedark .empname {\n  color: $dark-light-blue !important;\n}\n\n.bodythemedark .navitemli a {\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.bodythemedark .tabnavli a.settingsgeneral, \n.bodythemedark .tabnavli a.settingslinks:hover {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n.bodythemedark .tabnavli a.settingslinks {\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain ul li a,\n.headerthemedark .dropdown_menu_contain .dropdown_item, \n.headerthemedark .dropdown_menu_contain .dropdown_item h5 {\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain ul li a:hover,\n.headerthemedark .dropdown_menu_contain .dropdown_item:hover {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n}\n\n.dropdown_item:active {\n  background-color: $mainBg;\n}\n\n.profile_arrrow_dwn {\n  stroke: $darkTheme_blue;\n}\n\n.headerthemedark .profile_arrrow_dwn {\n  stroke: $white-color;\n}\n\n.dateinputbox1 input, \n.dateinputbox1 span {\n  color: $white-color !important;\n}\n\n/* LOGOUT MODAL */\n.modalStyleLight {\n\n}\n\n.modalStyleDark {\n  \n}\n\n\n@media only screen and (max-width: 1200px) {\n  .tableheadlight th {\n    min-width: 100px;\n  }\n}\n@media only screen and (max-width: 1024px) { \n  .dashboard {\n    width: calc(100% - 50px) !important;\n    left: 50px !important;\n    padding: 10px 10px !important;\n  }\n  .cont2 {\n    height: calc(100vh - 160px);\n    overflow-y: auto;\n  }\n}\n@media only screen and (max-width: 998px) { \n /* #dashboardcont2{\n    height: auto !important;\n  }*/\n}\n@media only screen and (max-width: 767px) { \n  .sectionright{\n    float: unset !important;\n  }\n  .dashboard {\n    padding: 10px 10px !important;\n  }\n}\n@media only screen and (max-width: 600px) {\n  .cont2 {\n    width: $dashwidth !important;\n    left: $dashleft !important;\n    position: relative !important;\n    padding: 10px !important;\n  }\n  .bodythemelight, .bodythemedark {\n    padding-top: 110px;\n  }\n}\n\n@media (min-width: 576px) {\n  .exer_modal_contain .modal-dialog {\n      max-width: 1055px;\n  }\n  .delPopContainer .modal-dialog {\n      max-width: 350px;\n  }\n}","@import \"../../styles/Variables/Variables.scss\";\n\n.settingsection{\n    margin-bottom: 50px;\n    padding-bottom:30px;\n\n    #settingsheading{\n        font-size: 18px;\n    }\n    .settingslinks{\n        text-decoration: none;\n        letter-spacing: 0.15em;\n        display: inline-block;\n        position: relative; \n    }\n\n    .settingsgeneral{\n        text-decoration: none;\n        letter-spacing: 0.15em;\n        display: inline-block;\n        position: relative; \n        color: $white-color;\n        background-color: $primary-btncolor;\n    }\n    .formthemedark .settingsgeneral{\n        background-color: $addBtn-dark-blue;\n    }\n\n    .settingslinks:hover{\n        color: $white-color;\n        background-color: $primary-btncolor;\n    }\n\n    .formthemedark .settingslinks:hover{\n        color: $white-color;\n        background-color: $addBtn-dark-blue;\n    }\n    \n    .settingsgeneral:hover{\n        color: $white-color;\n        background-color: $primary-btncolor;\n      }\n\n    // .settingslinks:after {    \n    //     background: none repeat scroll 0 0 transparent;\n    //     bottom: 0;\n    //     content: \"\";\n    //     display: block;\n    //     // height: 1.6px;\n    //     left: 50%;\n    //     position: absolute;\n    //     background:  $primary-btncolor;\n    //     transition: width 0.3s ease 0s, left 0.3s ease 0s;\n    //     width: 0;\n    //     border-bottom: 2px solid  $primary-btncolor;\n    //   }\n    //   .settingslinks:hover:after { \n    //     width: 100%; \n    //     left: 0; \n    //   }\n     \n     #layoutnav{\n        border-radius: 5px;\n     }\n\n      #addform{\n          margin-top: 30px;\n          padding: 30px;\n          border-radius: 5px;\n          display: flex;\n          form {\n            width: 100%;\n          }\n          .wrapper {\n            width: 100%;\n            padding-left: 30px;\n          }\n\n                .savebtn{\n                    border: none;\n                    border-radius: 5px;\n                    background-color: $primary-btncolor;\n                    padding: 10px;\n                    color: $white-color;\n                    font-size: 14px;\n                    margin-top: 10px;\n                }\n                .inputbox{\n                    border-radius: 5px;\n                    width: 100%;\n                    font-size: 14px;\n                }\n                .inputbox1{\n                    padding: 10px;\n                    border: none;\n                    border-radius: 5px;\n                    width: 100%;\n                    background-color: $darkTheme_darkBlue;\n                    color: $white-color;                     \n                }\n                .formlabel{\n                     \n                    font-size: 14px;\n                }\n                .formlabel1{\n                    color: #f8f9fa;\n                     \n                    font-size: 12px;\n                }\n\n                .logo{\n                    border: 1px solid rgb(81 83 101 / 28%);\n                    padding: 10px;\n                    margin-bottom: 20px;\n                    border-radius: 5px;\n                    width: 510px;\n                }\n                .editbtnsection{\n                    position: relative;\n                    margin-top: -37px;\n                }\n                \n                #penicon{\n                    margin-left:175px;\n                    font-size: 14px;\n                    background-color: $lightthemetext;\n                    padding: 5px;\n                    border-radius: 50%;\n                    color: #e9ecef;\n                    cursor: pointer;\n                \n                     &:hover{\n                        background-color: $primary-btncolor;\n                     }\n                }\n                \n      }\n}\n\n\n.formthemedark .settingsgeneral:hover{\n    background-color: $addBtn-dark-blue;\n  }\n\n.upload{\n    border: 1px solid #dee2e6;\n    background-color: #f8f9fa;\n    padding: 6px 0px 0px 3px;\n    width: 90px;\n    margin-left: 205px;\n    margin-top: -45px;\n    border-radius:5px;\n}\n.uploadicon{\n    color: $black-color;\n    font-size: 18px;\n    cursor: pointer;\n\n    &:hover{\n        color: $primary-btncolor;\n     }\n}\n.crossicon{\n    color: $black-color;\n    font-size: 16px;\n    margin-left: 40px;\n    cursor: pointer;\n\n    &:hover{\n       color: $primary-btncolor;\n     }\n\n}\n\n\n\n@media only screen and (max-width: 1200px) { \n    .logo{\n        width: 300px !important;\n    }\n}\n@media only screen and (max-width: 878px) {\n   #layoutnav{\n    display: flex !important;\n   }\n}\n\n@media only screen and (max-width: 768px) { \n    #addform{\n        display: block !important;\n    }\n    .wrapper {\n        padding-left: 0px !important;\n    }\n    .logo{\n        width: 100% !important;\n    }\n    .settingsection #layoutnav li {\n        margin-bottom: 10px;\n    }\n}\n@media only screen and (max-width: 548px) {\n\n    .settingslinks{\n     font-size: 14px !important;\n    }\n\n    .settingsgeneral{\n        font-size: 14px !important;\n    }\n }\n\n\n @media only screen and (max-width: 400px) {\n\n    .settingslinks{\n     margin-right: 0px !important;\n     font-size: 13px !important;\n    }\n\n    .settingsgeneral{\n        font-size: 13px !important;\n    }\n }\n\n@media only screen and (max-width: 600px) {\n    #dashboardcont2{\n        width: $dashwidth;\n        left: $dashleft;\n        position: relative;\n        padding: $dashboardpadding;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboard": `settings_dashboard__FHk5D`,
	"dashboardContain": `settings_dashboardContain__U2OSm`,
	"bodythemedark": `settings_bodythemedark__CUjRX`,
	"cont2": `settings_cont2__VlNwH`,
	"top_header": `settings_top_header__ff-Zj`,
	"top_header_inner": `settings_top_header_inner__CdYKG`,
	"footer": `settings_footer__P4xQU`,
	"bodythemelight": `settings_bodythemelight__daVLj`,
	"headerthemelight": `settings_headerthemelight__-DecU`,
	"headerthemedark": `settings_headerthemedark__VXMQL`,
	"menuthemelight": `settings_menuthemelight__xa936`,
	"menuthemedark": `settings_menuthemedark__0RlW9`,
	"menulinklight": `settings_menulinklight__2ukHf`,
	"menulinkdarkSelected": `settings_menulinkdarkSelected__qg5eL`,
	"menulinklightSelected": `settings_menulinklightSelected__-Sh8x`,
	"menulinkdark": `settings_menulinkdark__ZEp0Q`,
	"sub_arrow": `settings_sub_arrow__fGoo-`,
	"headinglight": `settings_headinglight__doSQ0`,
	"headingdark": `settings_headingdark__n+TEX`,
	"searchboxlight": `settings_searchboxlight__Exe8H`,
	"searchboxdark": `settings_searchboxdark__0LYGy`,
	"tableheadlight": `settings_tableheadlight__I2wDM`,
	"tableheaddark": `settings_tableheaddark__BAzcZ`,
	"table": `settings_table__wcs2I`,
	"table-borderless": `settings_table-borderless__XlVcO`,
	"left-section": `settings_left-section__Mo-jA`,
	"tablebodylight": `settings_tablebodylight__F8haX`,
	"tablebodydark": `settings_tablebodydark__qeszF`,
	"paginationlight": `settings_paginationlight__BGULt`,
	"paginationdark": `settings_paginationdark__Hz6pf`,
	"formthemelight": `settings_formthemelight__HnEnB`,
	"formthemedark": `settings_formthemedark__ffb0i`,
	"viewformlight": `settings_viewformlight__AIIgi`,
	"permissionboxlight": `settings_permissionboxlight__UvL2i`,
	"permissionboxdark": `settings_permissionboxdark__qBhr4`,
	"errormsgclr": `settings_errormsgclr__QmeiF`,
	"graphclrlight": `settings_graphclrlight__rlfpD`,
	"graphclrdark": `settings_graphclrdark__tho2P`,
	"card1bglight": `settings_card1bglight__mR3L5`,
	"card1bgdark": `settings_card1bgdark__HX9ph`,
	"card2bglight": `settings_card2bglight__+y-JH`,
	"card2bgdark": `settings_card2bgdark__Kfhe7`,
	"card3bglight": `settings_card3bglight__XbcQO`,
	"card3bgdark": `settings_card3bgdark__ILj6B`,
	"card4bglight": `settings_card4bglight__fGD5L`,
	"card4bgdark": `settings_card4bgdark__0tK9O`,
	"actionbtnlight": `settings_actionbtnlight__4Sk0H`,
	"actionbtndark": `settings_actionbtndark__La-Jh`,
	"profiledropdownlight": `settings_profiledropdownlight__NbgyO`,
	"profiledropdowndark": `settings_profiledropdowndark__D0QpQ`,
	"settingsection": `settings_settingsection__xu5at`,
	"addform": `settings_addform__Dk7Mj`,
	"savebtn": `settings_savebtn__yNpbe`,
	"profile_conatiner": `settings_profile_conatiner__rzq8z`,
	"ag-theme-alpine": `settings_ag-theme-alpine__wCbtM`,
	"ag-row": `settings_ag-row__xu1As`,
	"formbtn": `settings_formbtn__mm3Wt`,
	"resetbtn": `settings_resetbtn__FRARY`,
	"addBtn": `settings_addBtn__eaiUM`,
	"addbtnlight": `settings_addbtnlight__gWrRV`,
	"addbtndark": `settings_addbtndark__NmlKJ`,
	"cust_addBtn": `settings_cust_addBtn__OhiGl`,
	"deleteBtn": `settings_deleteBtn__bL4Ju`,
	"confirmBtn": `settings_confirmBtn__Wnp0z`,
	"delPopContainer": `settings_delPopContainer__FCjdY`,
	"modal-body": `settings_modal-body__MJgKL`,
	"delet_icon": `settings_delet_icon__uP6T3`,
	"arrowback": `settings_arrowback__qnVSX`,
	"drpdwn_btn": `settings_drpdwn_btn__PsPxB`,
	"empname": `settings_empname__6QldI`,
	"navitemli": `settings_navitemli__4IC51`,
	"tabnavli": `settings_tabnavli__-QWK2`,
	"settingsgeneral": `settings_settingsgeneral__0GBoO`,
	"settingslinks": `settings_settingslinks__vcT1Z`,
	"dropdown_menu_contain": `settings_dropdown_menu_contain__H2iGV`,
	"dropdown_item": `settings_dropdown_item__Ioitd`,
	"profile_arrrow_dwn": `settings_profile_arrrow_dwn__+vDFh`,
	"dateinputbox1": `settings_dateinputbox1__enon-`,
	"sectionright": `settings_sectionright__lAAyc`,
	"exer_modal_contain": `settings_exer_modal_contain__Yk2sS`,
	"modal-dialog": `settings_modal-dialog__6cI4N`,
	"settingsheading": `settings_settingsheading__E8AHc`,
	"layoutnav": `settings_layoutnav__xQYLn`,
	"wrapper": `settings_wrapper__FyIeM`,
	"inputbox": `settings_inputbox__7agbd`,
	"inputbox1": `settings_inputbox1__5RkFm`,
	"formlabel": `settings_formlabel__Bs5lx`,
	"formlabel1": `settings_formlabel1__b1qS9`,
	"logo": `settings_logo__2Nn6k`,
	"editbtnsection": `settings_editbtnsection__8ps9W`,
	"penicon": `settings_penicon__ZuNGm`,
	"upload": `settings_upload__Nn90h`,
	"uploadicon": `settings_uploadicon__tIHlL`,
	"crossicon": `settings_crossicon__Z8MI+`,
	"dashboardcont2": `settings_dashboardcont2__qbjfj`
};
export default ___CSS_LOADER_EXPORT___;
